import { useState, useEffect, useRef } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  // Reference to the banner element for focus management
  const bannerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  // When the banner becomes visible move keyboard focus to it
  useEffect(() => {
    if (visible) {
      bannerRef.current?.focus();
    }
  }, [visible]);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookieConsent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-title"
      aria-describedby="cookie-desc"
      tabIndex={-1}
      ref={bannerRef}
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        background: "#222",
        color: "white",
        padding: "1rem",
        textAlign: "center",
        zIndex: 1000,
        boxShadow: "0 -2px 6px rgba(0,0,0,0.2)",
      }}
    >
      <h2 id="cookie-title" style={{ marginTop: 0 }}>Cookie Einstellungen</h2>
      <p id="cookie-desc" style={{ marginBottom: "0.5rem" }}>
        Diese Website verwendet nur technisch notwendige Cookies, um eine
        einwandfreie Funktion sicherzustellen. Es werden keine Tracking- oder
        Analyse Cookies eingesetzt.
      </p>
      <div>
        <button
          type="button"
          onClick={acceptCookies}
          style={{
            marginRight: "0.5rem",
            padding: "0.4rem 1rem",
            background: "#4CAF50",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Akzeptieren
        </button>
        <button
          type="button"
          onClick={declineCookies}
          style={{
            padding: "0.4rem 1rem",
            background: "#666",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Ablehnen
        </button>
      </div>
    </div>
  );
}

